module.exports = __webpack_public_path__ + "static/media/arrow-down-right4.e7c0f5c3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/arrow-down-right4.svg
// module id = 2289
// module chunks = 7